import React from 'react'
import PaymentItem from './PaymentItem'
import AddPaymentForm from './AddPaymentForm'

export default class PaymentList extends React.Component {

  state = {adding: false}

  createPost = () => {
    this.setState({adding: true});
  }

  cancelAdd = () => {
    this.setState({adding: false});
  }

  render() {

    const { srvcs, pmnts, order, seller, payer, debt, updtBlnc, editPost } = this.props;

    const mappedData = pmnts.map( (el,num) => {
      return <PaymentItem
        num={num}
        key={el.post_id}
        post={el}
        srvcs={srvcs}
        editPost={editPost}
        updtBlnc={updtBlnc}
        blnc={this.props.blnc}
      />
    });

    const addPostForm = (this.state.adding) ?
      <AddPaymentForm
        data={{
          post_desc: "",
          post_srvc_id: 0,
          post_price: debt,
          post_qntt: 1,
          post_note: "",
          post_order_id: order.order_id,
          post_active: 1,
          post_avans: 1,
          post_payed:0,
          post_seller: seller,
          post_payer:payer,
          post_bdate:order.order_edate
        }}
        srvcs={srvcs}
        editPost={editPost}
        cancelAdd={this.cancelAdd}
        updtBlnc={updtBlnc}
        blnc={this.props.blnc}
      /> :
      <tr onClick={this.createPost} >
        <td></td>
        <td></td>
        <td></td>
        <td className="text-right"><u>Нажмите, чтобы добавить оплату</u></td>
      </tr>;

    return (
      <table className="table table-hover">
        <thead>
          <tr>
            <th className="col-xs-3">Метод оплаты</th>
            <th className="col-xs-2 text-right">Сумма</th>
            <th className="col-xs-2">Дата</th>
            <th className="col-xs-5">Заметка</th>
          </tr>
        </thead>
        <tbody>
          {mappedData}
          {addPostForm}
        </tbody>
      </table>
    )

  }
}



// WEBPACK FOOTER //
// ./src/components/payment/PaymentList.js